import React, { useEffect, useState } from "react";
import "../styles.css";
import Base from "./Base";
import Card from "./Card";
import { getProducts } from "./helper/coreapicalls";
import "./Home.css"

export default function Home() {
  const [product, setProducts] = useState([]);
  const [error, setError] = useState(false);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);


  const loadProducts = () => {
    setLoading(true);
    getProducts(page).then((data) => {
      if (data.msg === "NO PRODUCT FOUND") {
        setError("NO PRODUCT FOUND");
        setLoading(false);
      } else {
        setProducts(pre => [...pre, ...data]);
        setLoading(false);
      }
      console.log("data: ", data);
    });
  };

  useEffect(() => {
    loadProducts();
  }, [page]);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [])


  const handleScroll = () => {
    if (window.innerHeight + document.documentElement.scrollTop + 1 >= document.documentElement.scrollHeight) {
      setLoading(true);
      setPage(pre => pre + 1)
    }
  }



  // if (loading) {
  //   return <h1 className="text-white">Loading............</h1>
  // }

  return (
    <Base className="mt-1" title="Home Page" description="Welcome to the Cartify Store">
      <div className="container">
        <h1 className="text-center text-white mb-5">All Products</h1>
        <div className="row">
          {product.map((product, index) => (
            <div className="col-lg-4 col-md-6 col-sm-12 mb-4" key={index}>
              <Card product={product} />
            </div>
          ))}
        </div>
        {loading && (
          <div className="d-flex justify-content-center align-items-center">
            <div className="loader"></div>
          </div>
        )}
      </div>
    </Base>
  );

}
